import React from 'react'
import './footer.css'

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer id="contact" className="site-footer">
      <div className="footer-glow" aria-hidden="true"></div>
      <div className="footer-inner">
        <span className="footer-eyebrow">Discutons</span>
        <h2 className="footer-title">Un projet <br />en tête ?</h2>
        <a href="mailto:romain.danizel.pro@gmail.com" className="footer-cta">
          romain.danizel.pro@gmail.com <span>↗</span>
        </a>

        <div className="footer-bottom">
          <span className="footer-copy">© {year} Romain Danizel</span>
          <div className="footer-links">
            <a href="https://github.com/Meanzar" target="_blank" rel="noreferrer">GitHub</a>
            <a href="#">LinkedIn</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
